
import { Component, Vue, Prop } from "vue-property-decorator";
import CourseItem from "./CourseItem.vue";
import BlmCourseItem from "./BlmCourseItem.vue";
@Component({
  components: {
    CourseItem,
    BlmCourseItem
  }
})
export default class Course extends Vue {
  @Prop({ required: true }) private list!: any;
  @Prop({ required: true }) private blmCourseList!: any;
  @Prop({ required: true }) private courseType!: any;

  // 点击切换
  handleBtn(key: any) {
    this.$emit("changeCourse", key);
  }
  // 点击更多
  handleMore() {
    this.$router.push(`/course?type=${this.courseType}`);
  }
}
